module.exports = __webpack_public_path__ + "img/big.c87b0c37.jpg";